import {
  IHttpApi,
  mergeBaseUri,
  mergePaths,
  transformObjectToQuery,
  IHTTPRequestConfig,
  IHTTPCompletedResponse,
} from '@cian/http-api';

import { ISubscribeToCommentsRequest, ISubscribeToCommentsConfig, TResponses } from './types';

const defaultConfig: Required<ISubscribeToCommentsConfig> = {
  pathApi: '/v2/subscribe-comment',
  browserUrl: 'http://www.master.dev3.cian.ru/content-api',
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const defaultRequest: IHTTPRequestConfig<any> = {
  uri: {
    host: '',
    path: '',
  },
  method: 'POST',
  requestType: 'formData',
  body: '',
  withCredentials: true,
  headers: [['Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8']],
};

function createSubscribeToCommentsRequest({
  bodyParameters,
  config,
}: Pick<ISubscribeToCommentsOptions, 'bodyParameters' | 'config'>): IHTTPRequestConfig<any> {
  const { pathApi, browserUrl } = { ...defaultConfig, ...config };

  return {
    ...defaultRequest,
    uri: mergeBaseUri(browserUrl, {
      path: (path: string) => mergePaths(path, pathApi),
    }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    body: transformObjectToQuery(bodyParameters as any).unwrap() as any,
  };
}

export interface ISubscribeToCommentsOptions {
  httpApi: IHttpApi;
  bodyParameters: ISubscribeToCommentsRequest;
  config?: ISubscribeToCommentsConfig;
}

async function fetchSubscribeToComments({
  httpApi,
  bodyParameters,
  config,
}: ISubscribeToCommentsOptions): Promise<IHTTPCompletedResponse<TResponses>> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return httpApi.httpRequest(createSubscribeToCommentsRequest({ bodyParameters, config })) as any;
}

export { defaultConfig, createSubscribeToCommentsRequest, fetchSubscribeToComments };
